import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { apiFetch } from "./api";
import logo from "../logo-leasein.png";

export default function PortalLayout() {
  const { client, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [flags, setFlags] = useState({ programari_viitoare: 0, facturi_neplatite: 0 });

  useEffect(() => {
    apiFetch("/flags")
      .then((d) => { if (d && d.ok && d.flags) setFlags(d.flags); })
      .catch(() => {});
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const linkuri = [
    { to: "/portal", end: true, icon: "grid", text: "Dashboard" },
    { to: "/portal/masini", icon: "car", text: "Mașinile mele" },
    { to: "/portal/facturi", icon: "invoice", text: "Facturi", dot: flags.facturi_neplatite > 0 ? "rosu" : null },
    { to: "/portal/refacturari", icon: "swap", text: "Refacturări" },
    { to: "/portal/programari", icon: "wrench", text: "Programări", dot: flags.programari_viitoare > 0 ? "albastru" : null },
    { to: "/portal/solicitari", icon: "ticket", text: "Solicitări" },
    { to: "/portal/imputerniciri", icon: "stamp", text: "Împuterniciri" },
    { to: "/portal/cont", icon: "user", text: "Contul meu" },
  ];

  return (
    <div className="portal">
      <aside className={`portal__sidebar ${open ? "open" : ""}`}>
        <Link to="/" className="portal__logo">
          <img src={logo} alt="LEASEIN" />
        </Link>
        <nav className="portal__nav">
          {linkuri.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `portal__navlink ${isActive ? "active" : ""}`
              }
              onClick={() => setOpen(false)}
            >
              <Icon name={l.icon} />
              <span>{l.text}</span>
              {l.dot && <span className={`nav-dot nav-dot--${l.dot}`} />}
            </NavLink>
          ))}
        </nav>
        <Link to="/" className="portal__backsite">
          <Icon name="home" />
          <span>Înapoi la site</span>
        </Link>
        <button className="portal__logout" onClick={handleLogout}>
          <Icon name="logout" />
          <span>Deconectare</span>
        </button>
      </aside>

      <div className="portal__main">
        <header className="portal__topbar">
          <button
            className="portal__burger"
            aria-label="Meniu"
            onClick={() => setOpen((o) => !o)}
          >
            <span></span><span></span><span></span>
          </button>
          <div className="portal__user">
            <span className="portal__user-name">{client?.numeFirma}</span>
            <span className="portal__user-avatar">
              {client?.numeFirma?.charAt(0) || "C"}
            </span>
          </div>
        </header>
        <main className="portal__content">
          <Outlet />
        </main>
      </div>

      {open && <div className="portal__overlay" onClick={() => setOpen(false)} />}
    </div>
  );
}

function Icon({ name }) {
  const paths = {
    grid: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>,
    car: <><path d="M5 11l1.5-4.5A2 2 0 018.4 5h7.2a2 2 0 011.9 1.5L19 11" /><path d="M3 11h18v5a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H6v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-5z" /><circle cx="7" cy="14" r="1" /><circle cx="17" cy="14" r="1" /></>,
    invoice: <><path d="M6 2h9l5 5v13a1 1 0 01-1 1H6a1 1 0 01-1-1V3a1 1 0 011-1z" /><path d="M14 2v6h6" /><path d="M9 13h6" /><path d="M9 17h6" /><path d="M9 9h2" /></>,
    ticket: <><path d="M3 9a2 2 0 012-2h14a2 2 0 012 2 2 2 0 000 4 2 2 0 01-2 2H5a2 2 0 01-2-2 2 2 0 000-4z" /><path d="M14 7v10" strokeDasharray="2 2" /></>,
    user: <><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0112 0v1" /></>,
    logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></>,
    home: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10a1 1 0 001 1h3v-6h6v6h3a1 1 0 001-1V10" /></>,
    swap: <><path d="M4 7h13" /><path d="M14 4l3 3-3 3" /><path d="M20 17H7" /><path d="M10 14l-3 3 3 3" /></>,
    wrench: <><path d="M14.7 6.3a4 4 0 01-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 015.4-5.4l-2.5 2.5-2-2 2.5-2.5z" /></>,
    stamp: <><path d="M12 3a3 3 0 013 3c0 1.4-.7 2.6-1.4 3.7-.4.7-.6 1.3-.6 1.8h-2c0-.5-.2-1.1-.6-1.8C9.7 8.6 9 7.4 9 6a3 3 0 013-3z" /><path d="M6 14.5A1.5 1.5 0 017.5 13h9a1.5 1.5 0 011.5 1.5V17H6v-2.5z" /><path d="M4 20h16" /></>,
  };
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
}
